import { render, staticRenderFns } from "./contract_draft.vue?vue&type=template&id=65add18d&scoped=true"
import script from "./contract_draft.vue?vue&type=script&lang=js"
export * from "./contract_draft.vue?vue&type=script&lang=js"
import style0 from "./contract_draft.vue?vue&type=style&index=0&id=65add18d&prod&lang=css"
import style1 from "./contract_draft.vue?vue&type=style&index=1&id=65add18d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65add18d",
  null
  
)

export default component.exports